import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerCustomerWaitingHoursDetailViewModel, DealerCustomerWaitingHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-customer-waiting-hours-view-model';
import { OccasionalShiftSaveViewModel } from 'projects/Administration/src/app/business-entities/occasionalshift-save-view-model';
import { DealerCustomerWaitingHoursSaveModel } from 'projects/Administration/src/app/business-entities/dealer-customer-waiting-hours-save-model';
import { DealerWorkingHoursBusinessService } from 'projects/Administration/src/app/business-services/dealer-working-hours.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-dealer-customer-waiting-hours',
  templateUrl: './edit-dealer-customer-waiting-hours.component.html',
  styleUrl: './edit-dealer-customer-waiting-hours.component.css'
})
export class EditDealerCustomerWaitingHoursComponent implements OnInit {

  @Input() dealerId: string;
  addOccasionalWorkingHoursForm: FormGroup;
  startdate: string;
  enddate: string;
  isDisable: boolean = false;
  isDatesDisable: boolean = false;
  selectedRadioButton: any = 0;
  previousRadioButton: any = 0;
  isDelete: boolean = false;
  occasionList: OccasionalShiftSaveViewModel[] = [];
  dealerCustomerWaitingHours: DealerCustomerWaitingHoursDetailViewModel[];
  dealerCustomerWaitingHoursOccasionList: DealerCustomerWaitingHoursViewModel[];
  dealerCustomerWaitingWorkingHours: any;
  deliveryTimeSlot: any = { hour: 0o00, minute: 0o00 };
  isUpdatedValue: boolean = false;
  originalOccasionName: string = "";
  originalStartDate: string = null;
  hasFormChanges: boolean = false;
  minDate: string;
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private cdrf: ChangeDetectorRef,
    private toastr: ToastrService,
    private translate: TranslateService,
    private readonly dealerWorkingHoursService: DealerWorkingHoursBusinessService,
    private readonly spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.minDate = moment().format('YYYY/MM/DD');
    this.addOccasionalWorkingHoursForm = this.formBuilder.group({
      occasionname: ['', [Validators.required]],
      startdate: ['', [Validators.required]],
      enddate: [''],
    });
    this.addOccasionalWorkingHoursForm.valueChanges.subscribe(() => {
      this.checkFormChanges();
    });
    this.GetWorkingHoursDetails();
  }

  OnClear() {
    this.startdate = null;
    this.enddate = null;
    this.addOccasionalWorkingHoursForm.patchValue({
      occasionname: '',
      startdate: null,
      enddate: null
    });
    this.originalOccasionName = '';
    this.originalStartDate = null;
    this.hasFormChanges = false;
    this.isDisable = false;
    this.selectedRadioButton = 0;
    this.isDatesDisable = false;
    this.isDelete = false;
  }

  get cpf() {
    return this.addOccasionalWorkingHoursForm.controls;
  }

  async AddWorkingHoursDetails() {
    this.cdrf.detectChanges();
    let endDate = this.addOccasionalWorkingHoursForm.value.enddate ? Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalWorkingHoursForm.value.enddate)) : null;
    let startDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalWorkingHoursForm.value.startdate))

    if (this.addOccasionalWorkingHoursForm.value.enddate && !this.validateDateTime(this.addOccasionalWorkingHoursForm.value.startdate, this.addOccasionalWorkingHoursForm.value.enddate)) {
      return;
    }

    let occasionalWorkingHoursViewModel =
    {
      rowId: this.selectedRadioButton,
      occasionName: this.addOccasionalWorkingHoursForm.value.occasionname,
      startDate: startDate,
      endDate: endDate,
      dealerId: this.dealerId
    }
    await this.dealerWorkingHoursService.addUpdateDealerCustomerWaitingHours(occasionalWorkingHoursViewModel).then((result) => {
      if (result) {
        if (result.responseMessage != null && result.responseMessage != '') {
          this.toastr.error(result.responseMessage);
          return;
        }
        this.OnClear();
        this.toastr.success(Constant.SuccessfullyAdded);
        this.dealerCustomerWaitingHoursOccasionList = result.responseObject;
        this.selectedRadioButton = this.selectedRadioButton == 0 ? result.responseObject[result.responseObject.length - 1].rowId : this.selectedRadioButton;
        this.ChangeOccasion();
      }
    });
  }

  async GetWorkingHoursDetails() {
    await this.dealerWorkingHoursService.getDealerCustomerWaitingHoursDetails(this.dealerId).then((result) => {
      if (result) {
        this.dealerCustomerWaitingHoursOccasionList = result.responseObject;
        if (result.responseObject.length > 0) {
          this.selectedRadioButton = result.responseObject[0].rowId;
          this.loadShiftDetails();
        }
      }
    });
  }

  validateDateTime(startDate: Date, endDate: Date) {
    if (endDate < startDate) {
      this.toastr.error(Constant.DateRangeValidation);
      return false;
    }
    return true;
  }


  ChangeOccasion() {
    if (this.isUpdatedValue) {
      this.toastr.warning(this.translate.instant('lblSaveOccasionChange'));
      setTimeout(() => {
        this.selectedRadioButton = this.previousRadioButton;
      }, 0);
    }
    else {
      this.loadShiftDetails();
    }
  }

  loadShiftDetails() {
    this.previousRadioButton = this.selectedRadioButton;
    this.cdrf.detectChanges();
    let SelectedInput = this.dealerCustomerWaitingHoursOccasionList.filter(x => x.rowId == this.selectedRadioButton);
    this.startdate = (SelectedInput[0].startDate) ? Utility.GetFormattedDate(SelectedInput[0].startDate) : null;
    this.enddate = (SelectedInput[0].endDate) ? Utility.GetFormattedDate(SelectedInput[0].endDate) : null;
    this.addOccasionalWorkingHoursForm.patchValue({
      occasionname: SelectedInput[0].occasionName,
      startdate: this.startdate,
      enddate: this.enddate
    })
    this.originalOccasionName = SelectedInput[0].occasionName;
    this.originalStartDate = this.startdate;
    this.hasFormChanges = false;
    this.isDisable = true;
    if (this.selectedRadioButton == 1) {
      this.isDatesDisable = true;
      this.isDelete = false;
    }
    else {
      this.isDatesDisable = false;
      if (Utility.getDateStringToDate(this.startdate) > new Date()) {
        this.isDelete = true;
      }
      else {
        this.isDelete = false;
      }
    }
    this.cdrf.detectChanges();
    this.getDealerWorkingHours();
  }

  async getDealerWorkingHours() {
    this.spinner.show();
    let result = await this.dealerWorkingHoursService.getDealerCustomerWaitingHoursDetailsById(this.dealerId, this.selectedRadioButton);
    this.dealerCustomerWaitingWorkingHours = result.responseObject;
    this.dealerCustomerWaitingWorkingHours.forEach(day => {
      day.deliveryTimeSlot = { hour: 0o00, minute: 0o00 };
      day.maxCustomerWaitingNo = 0;
      day.originalIsActive = day.isActive;
      if (day.waitingSlots && day.waitingSlots.length > 0) {
        day.waitingSlots.forEach(slot => {
          slot.isAddedNew = false;
        });
      }
    });
    this.spinner.hide();
    this.checkForUpdates();
  }

  onTimeSlotAdd(workingDayNumber: any, occasionId: any) {
    let workingDay = this.dealerCustomerWaitingWorkingHours.find(x => x.dayNumber === workingDayNumber && x.occasionId === occasionId);
    if (!workingDay) {
      return;
    }
    if (workingDay.maxCustomerWaitingNo == undefined || workingDay.maxCustomerWaitingNo == 0 || workingDay.maxCustomerWaitingNo < 0) {
      this.toastr.error(this.translate.instant('lblNoNegativeNumber'));
      return;
    }
    if (workingDay.deliveryTimeSlot && (workingDay.deliveryTimeSlot.hour > 0 || workingDay.deliveryTimeSlot.minute > 0)) {
      const localDateTime = moment().hours(workingDay.deliveryTimeSlot.hour).minutes(workingDay.deliveryTimeSlot.minute).seconds(0).milliseconds(0).format('HH:mm');

      // Check if the same time slot already exists for this day
      let duplicateRecordIndex = workingDay.waitingSlots?.findIndex(x => x.openingTime === localDateTime);
      if (duplicateRecordIndex >= 0) {
        workingDay.deliveryTimeSlot = { hour: 0, minute: 0 };
        workingDay.maxCustomerWaitingNo = 0;
        this.toastr.error(this.translate.instant('lblClashingDate'));
        return;
      }

      if (!workingDay.waitingSlots) {
        workingDay.waitingSlots = [];
      }
      // Mark existing slots as not new
      workingDay.waitingSlots.forEach(slot => {
        if (slot.isAddedNew === undefined) {
          slot.isAddedNew = false;
        }
      });

      // Add new slot with isAddedNew flag
      workingDay.waitingSlots.push({
        openingTime: localDateTime,
        dayNumber: workingDayNumber,
        occasionId: occasionId,
        maxCustomerWaitingNo: workingDay.maxCustomerWaitingNo,
        isAddedNew: true
      });

      // Reset only this day's time picker
      workingDay.deliveryTimeSlot = { hour: 0, minute: 0 };
      workingDay.maxCustomerWaitingNo = 0;
      this.checkForUpdates();
    }
  }

  onTimeSlotDelete(occasionId: any, customerWaitingSlotId: any, openingTime: any, dayNumber: any) {
    if (customerWaitingSlotId === 0 || customerWaitingSlotId === null || customerWaitingSlotId === undefined) {
      this.dealerCustomerWaitingWorkingHours.forEach(day => {
        if (day.dayNumber === dayNumber && day.waitingSlots && day.waitingSlots.length > 0) {
          day.waitingSlots = day.waitingSlots.filter(slot => slot.openingTime !== openingTime);
          if (day.waitingSlots.length === 0) {
            day.isActive = false;
            day.originalIsActive = false;
          }
        }
      });
      this.checkForUpdates();
      return;
    }
    this.spinner.show();
    let deleteModel = {
      dealerId: this.dealerId,
      occasionId: occasionId,
      customerWaitingSlotId: customerWaitingSlotId
    };
    this.dealerWorkingHoursService.deleteDealerCustomerWaitingHours(deleteModel).then((result) => {
      if (result.responseObject) {
        this.toastr.success(this.translate.instant('lblTimeSlotDeleted'));
        this.dealerCustomerWaitingWorkingHours.forEach(day => {
          if (day.dayNumber === dayNumber && day.waitingSlots && day.waitingSlots.length > 0) {
            day.waitingSlots = day.waitingSlots.filter(slot => slot.id !== customerWaitingSlotId);
            if (day.waitingSlots.length === 0) {
              day.isActive = false;
              day.originalIsActive = false;
            }
          }
        });
        this.spinner.hide();
        this.checkForUpdates();
      }
      else {
        this.spinner.hide();
        this.checkForUpdates();
      }
    });
  }

  checkForUpdates() {
    const hasNewSlots = this.dealerCustomerWaitingWorkingHours.some(day =>
      day.waitingSlots?.some((slot: { isAddedNew: boolean; }) => slot.isAddedNew === true)
    );
    const hasIsActiveChanges = this.dealerCustomerWaitingWorkingHours.some(day =>
      day.isActive !== day.originalIsActive
    );
    this.isUpdatedValue = hasNewSlots || hasIsActiveChanges;
  }

  onIsActiveChange(day: any) {
    if (!day.waitingSlots || day.waitingSlots.length === 0) {
      setTimeout(() => {
        day.isActive = !day.isActive;
      }, 0);
      this.toastr.error(this.translate.instant('lblAddOneSlot'));
      return;
    }
    // If slots exist, proceed with the change
    this.checkForUpdates();
  }

  onMaxCustomerWaitingNoInput(workingHours: any) {
    const currentValue = (workingHours.maxCustomerWaitingNo ?? '').toString();
    const leadingIntegerPart = currentValue.match(/^\d{0,2}/)?.[0] ?? '';
    workingHours.maxCustomerWaitingNo = leadingIntegerPart === '' ? null : Number(leadingIntegerPart);
  }

  async onSaveChanges(isSaveAndClose) {
    const saveModel: DealerCustomerWaitingHoursSaveModel = {
      dealerId: this.dealerId,
      occasionId: this.selectedRadioButton,
      waitingSlots: []
    };

    this.dealerCustomerWaitingWorkingHours.forEach(day => {
      if (day.waitingSlots && day.waitingSlots.length > 0) {
        const hasNewSlots = day.waitingSlots.some(x => x.isAddedNew);
        const isActiveChanged = day.isActive !== day.originalIsActive;

        if (hasNewSlots || isActiveChanged) {
          const slotsToSave = hasNewSlots && !isActiveChanged
            ? day.waitingSlots.filter(x => x.isAddedNew)
            : day.waitingSlots;

          slotsToSave.forEach(slot => {
            saveModel.waitingSlots.push({
              id: slot.id ? slot.id : 0,
              day: day.day,
              dayNumber: day.dayNumber,
              isActive: day.isActive,
              timeHrs: slot.openingTime,
              maxCustomerWaitingNo: slot.maxCustomerWaitingNo
            });
          });
        }
      }
    });
    this.dealerCustomerWaitingWorkingHours = await this.dealerWorkingHoursService.saveDealerCustomerWaitingHours(saveModel);
    this.toastr.success(this.translate.instant('lblDealerCustomerWaiting'));
    this.dealerCustomerWaitingWorkingHours.forEach(day => {
      day.deliveryTimeSlot = { hour: 0, minute: 0 };
      day.maxCustomerWaitingNo = 0;
      day.originalIsActive = day.isActive;
      if (day.waitingSlots && day.waitingSlots.length > 0) {
        day.waitingSlots.forEach(slot => {
          slot.isAddedNew = false;
        });
      }
    });

    this.isUpdatedValue = false;
    if (isSaveAndClose)
      this.activeModal.close({ success: true });
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }

  async OnDelete() {
    await this.dealerWorkingHoursService.deleteDealerCustomerWaitingSlotHours(this.selectedRadioButton).then((result) => {
      if (result) {
        this.toastr.success("lblSuccesfullyDeletedSpecialOccasion");
        this.dealerCustomerWaitingHoursOccasionList = this.dealerCustomerWaitingHoursOccasionList.filter(x => x.rowId != this.selectedRadioButton);
        this.selectedRadioButton = this.dealerCustomerWaitingHoursOccasionList.length > 0 ? this.dealerCustomerWaitingHoursOccasionList[0].rowId : 0;
        if (this.selectedRadioButton != 0) {
          this.loadShiftDetails();
        }
      }
    });
  }

  checkFormChanges() {
    const currentOccasionName = this.addOccasionalWorkingHoursForm.value.occasionname || '';
    const currentStartDate = this.addOccasionalWorkingHoursForm.value.startdate || null;

    this.hasFormChanges =
      currentOccasionName !== this.originalOccasionName ||
      currentStartDate !== this.originalStartDate
  }
}